'use client';

import dynamic from 'next/dynamic';
import { FormattedMessageProps } from '../../../components/FormattedMessage';

const ClientFormattedMessage = dynamic(
  () => import('./ClientFormattedMessage'),
  { ssr: false },
);
/**
 * PagesRouterFormattedMessage.
 * @param props
 * @returns
 */
const PagesRouterFormattedMessage = (props: FormattedMessageProps) => (
  <ClientFormattedMessage {...props} />
);

export default PagesRouterFormattedMessage;
